import { render } from "./vrefundapplication.vue?vue&type=template&id=66f05d98&scoped=true"
import script from "./vrefundapplication.vue?vue&type=script&lang=js"
export * from "./vrefundapplication.vue?vue&type=script&lang=js"

import "./vrefundapplication.vue?vue&type=style&index=0&id=66f05d98&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f05d98"]])

export default __exports__